import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../common/tab/tabActions';

const INITIAL_VALUES = {}

export function getList() {
    const request = axiosInstance.get(`/usuarios`)
    
    return {
        type: 'USUARIO_FETCHED',
        payload: request
    }
}

export const setPaginaAtual = (pagina) => ({
    type: 'USUARIO_PAGE',
    payload: pagina 
});

export function create(values) {
    return submit(values, 'post');
}

export function update(values) {    
    return submit(values, 'put')
}

export function remove(values) {
    return submit(values, 'delete');
}

function submit(values, method) {    
    
    // Converte o valor de gruposFisicos para o formato esperado pelo backend
    if (values.gruposFisicos && parseInt(values.gruposFisicos, 10) > 0) {
        values.gruposFisicos = [parseInt(values.gruposFisicos, 10)];
    } else {
        values.gruposFisicos = [];
    }

    return dispatch => {
        const id = values.id ? values.id : '';
        
        // se for um delete tem que adicionar como data para aparecer no body do backend e gravar o log
        if (method === 'delete'){
            values = {data: values };
        }

        axiosInstance[method](`/usuarios/${id}`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            })
            .catch(e => {
                e.response.data.errors.forEach(error => toastr.error('Erro', error))
            })
    }
}

export function showUpdate(usuario) {
    // Converte o array de gruposFisicos para um valor único para o select
    // Se não tem grupos específicos ou array vazio, significa "Todos" (valor vazio)
    // Se tem apenas um grupo, usa esse valor
    // Se tem múltiplos grupos, usa o primeiro (para compatibilidade)
    const usuarioFormatado = {
        ...usuario,
        gruposFisicos: usuario.gruposFisicos && usuario.gruposFisicos.length > 0 
            ? usuario.gruposFisicos[0] 
            : '' // Valor vazio representa "Todos os Grupos Físicos"
    };

    return [
        showTabs('tabUpdate'),
        selectTab('tabUpdate'),
        initialize('usuarioForm', usuarioFormatado)
    ]
}

export function showDelete(usuario) {
    return [
        showTabs('tabDelete'),
        selectTab('tabDelete'),
        initialize('usuarioForm', usuario)
    ]
}

export function init() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
        { type: 'NOTIFICACAO_USUARIO_CLEAR' },
        initialize('usuarioForm', INITIAL_VALUES)
    ]
}